import * as React from 'react';
import {SubmitHandler} from 'redux-form';
import {AmazonSeller, EbayListing, AmazonListing} from 'cl-api';
import {AMAZON_LISTINGS_ACTIONS_TYPES, EBAY_LISTINGS_ACTIONS_TYPES, GENERAL_ACTIONS_TYPES} from './ActionsTypes';
import {StoreState} from '../../App/initialStore';

export interface BaseActionsProps {
  types: Array<EBAY_LISTINGS_ACTIONS_TYPES | GENERAL_ACTIONS_TYPES | AMAZON_LISTINGS_ACTIONS_TYPES>;
  displayType: string;
  handleSubmit?: SubmitHandler;
  lastActionColor?: string;
  additionalActionData?: any;
  id?: string;
}

type ObjectTypes = EbayListing | AmazonSeller | AmazonListing;

export interface ActionsManagerProps extends BaseActionsProps {
  objectType: OBJECT_TYPES_NAMES;
  objects: Array<ObjectTypes>;
  storeProps?: {[actionType: string]: Partial<ActionsStoreProps>};
  noObjects?: boolean;
}

export interface ActionsDisplayProps {
  label: string;
  icon?: React.ReactElement<any>;
  IconAfterLabel?: boolean;
  tooltip?: string;
  busyLabel?: string;
}

export enum ACTION_DISPLAY_TYPES {
  FLAT_BUTTON = 'flatButton',
  RAISED_BUTTON = 'raisedButton',
  ICON_BUTTON = 'iconButton',
  MENU_ITEM = 'menuItem',
  SPLIT_BUTTON = 'splitButton',
  INLINE_BUTTON = 'inlineButton',
}

export enum OBJECT_TYPES_NAMES {
  LISTING = 'listing',
  GENERAL = 'general',
  AMAZON_ACCOUNT = 'amazonAccount',
  AMAZON_LISTING = 'amazonListing',
}

export interface ActionsStoreProps {
  dirty: boolean;
  nonDraft: boolean;
  hasVariationsToAdd: boolean;
  hasVariations: boolean;
  amazonListingsSyncComplete: boolean;
  emptyEditVariationsForm: boolean;
  allVariationsSelected: boolean;
}

export interface ActionProps<ObjectType = ObjectTypes> {
  getStoreProps?(state: StoreState): Partial<ActionsStoreProps>;
  shouldRender?(object: ObjectType, storeProps: Partial<ActionsStoreProps>, additionalActionData?: any): boolean;
  action(objects?: ObjectType[], ref?: React.RefObject<React.ReactInstance>, additionalActionData?: any): () => void;
  isDisabled?(objects: ObjectType[], storeProps: Partial<ActionsStoreProps>): boolean;
  displayElementsProps: any;
  singleObjectOnly?: boolean;
  verifyUser?: boolean;
  getTooltip?(objects: ObjectType[], storeProps: Partial<ActionsStoreProps>): string;
  objectIsOptional?: boolean;
}
